import { FC, ReactNode } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

interface NewsletterFormPageLayoutProps {
  backgroundColor: string;
  slots: {
    organizationBanner: ReactNode;
    form: ReactNode;
  };
}

export const NewsletterFormPageLayout: FC<NewsletterFormPageLayoutProps> = ({ backgroundColor, slots }) => {
  return (
    <Box
      sx={{
        backgroundColor,
        padding: (theme) => theme.spacing(2, 3),
        height: "100%",
        flex: 1,
        display: "flex",
      }}
    >
      <Stack direction="column" gap={{ xs: 2, md: 3 }} alignItems="center" justifyContent="center" width="100%">
        {slots.organizationBanner}
        {slots.form}
      </Stack>
    </Box>
  );
};
